import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'

export default (props) => {
  return <RedirectTemplate location={props.location} destination="/tv/" />

  // return (
  //   <PPVTemplate
  //     lang="en"
  //     market="us"
  //     location={props.location}
  //     title="AEW: Double or Nothing 2025"
  //     subtitle="WATCH LIVE THIS SUNDAY, MAY 25 ON PAY PER VIEW WITH FUBO"
  //     video={videoURI + 'compressed/AEW_Wrestling_LP_10s_16x9.mp4'}
  //     videoMobile={videoURI + 'mobile/AEW_Wrestling_LP_10s_1x1.mp4'}
  //     offerCode={promoCodes.aew_double_or_nothing}
  //     dealcloudDvr={'No base plan required.'}
  //     platformHeadline="Stream live and on demand from anywhere"
  //     platformFootnote="Not yet available on Roku"
  //     additionalFAQs={additionalFAQs}
  //     platformExcludedDevices={['Roku']}
  //   />
  // )
}

// const additionalFAQs = [
//   {
//     question: 'Can I watch AEW Double or Nothing 2025 on Fubo?',
//     answer:
//       'Yes, you can watch AEW Double or Nothing 2025 on Fubo. It is available as a Pay Per View event.',
//   },
//   {
//     question: 'How do I find AEW Double or Nothing 2025 on Fubo?',
//     answer:
//       'If you ordered the AEW Double or Nothing 2025 Pay Per View event, you will see it in your channel guide. To find the channel guide, simply open the Fubo app on any of your devices and click Guide.',
//   },
//   {
//     question: 'Can I watch AEW commentary and analysis on Fubo?',
//     answer:
//       'Yes, if you order the Pay Per View you will have access to the “Zero Hour” preshow, plus “Road To Double or Nothing” and “Countdown to Double or Nothing.” Get all the storyline updates, interviews and analysis you’ll need before the event.',
//   },
//   {
//     question: 'Will AEW Double or Nothing 2025 be replayed on Fubo?',
//     answer:
//       'Yes, if you miss the event or want to watch it again, AEW Double or Nothing 2025 will be available to replay for a period of time after the event ends.',
//   },
//   {
//     question: 'What related AEW content can I find on Fubo?',
//     answer:
//       'If you like AEW, you’ll love the variety of pro wrestling, boxing and other combat sports on Fubo. With a Fubo subscription you can watch WWE, UFC, BKFC and more. Plus behind-the-scenes shows and special events for fans of every sport and league.',
//   },
// ]
